export default "__VITE_ASSET__DB$mUOIl__"